var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgActiveAgency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 152,
    viewBox: "0 0 154 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 76,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 76,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 76,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75.5C16.5 42.3629 43.3629 15.5 76.5 15.5C109.637 15.5 136.5 42.3629 136.5 75.5C136.5 108.637 109.637 135.5 76.5 135.5C43.3629 135.5 16.5 108.637 16.5 75.5Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5052 47.3738L104.005 70.1585C105.828 71.3236 107 73.395 107 75.4663C107 77.6671 105.828 79.7384 104.005 80.7741L66.5052 103.559C64.5521 104.724 62.0781 104.853 60.125 103.688C58.1719 102.653 57 100.581 57 98.2509V52.6816C57 50.4808 58.1719 48.4095 60.125 47.3738C62.0781 46.2087 64.5521 46.2087 66.5052 47.3738Z",
    fill: "url(#paint0_linear_4061_53440)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4061_53440",
    x1: 82,
    y1: 46.5,
    x2: 82,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgActiveAgency);
export default __webpack_public_path__ + "static/media/img_active_agency.1c2801a11d8cd247fb08d292251db756.svg";
export { ForwardRef as ReactComponent };